const OBJECT_ID = /^[a-f\d]{24}$/i;
const REFERRER_KEY = 'logictry_purchase_referrer';

function storedReferrer() {
  try {
    const stored = window.sessionStorage.getItem(REFERRER_KEY);
    if (stored && OBJECT_ID.test(stored)) return stored;
  } catch {
    return '';
  }
  return '';
}

function currentReferrer() {
  if (typeof window === 'undefined') return '';
  try {
    const fromUrl = new URLSearchParams(window.location.search).get('referrer');
    if (fromUrl && OBJECT_ID.test(fromUrl)) {
      try { window.sessionStorage.setItem(REFERRER_KEY, fromUrl); } catch { /* private mode */ }
      return fromUrl;
    }
  } catch {
    return storedReferrer();
  }
  return storedReferrer();
}

export function withPurchaseReferrer(href, extra) {
  const referrerId = currentReferrer();
  if (!referrerId) return href;
  const splitAt = href.indexOf('?');
  const path = splitAt === -1 ? href : href.slice(0, splitAt);
  const params = new URLSearchParams(splitAt === -1 ? '' : href.slice(splitAt + 1));
  if (extra) {
    Object.entries(extra).forEach(([key, value]) => {
      if (value && !params.get(key)) params.set(key, value);
    });
  }
  if (!params.get('referrer')) params.set('referrer', referrerId);
  const query = params.toString();
  return query ? `${path}?${query}` : path;
}

export function membershipApplyHref(href) {
  return withPurchaseReferrer(href);
}

export function attendApplyHref(href) {
  return withPurchaseReferrer(href);
}

export function purchaseCheckoutFields() {
  const referrerId = currentReferrer();
  if (!referrerId) return {};
  return { referrer: referrerId };
}

/** Payment Links accept the referrer as client_reference_id. Other URLs stay unchanged. */
export function stripeLinkWithReferrer(url) {
  const referrerId = currentReferrer();
  if (!referrerId || !url) return url;
  try {
    const parsed = new URL(url);
    if (parsed.hostname !== 'buy.stripe.com') return url;
    if (!parsed.searchParams.get('client_reference_id')) {
      parsed.searchParams.set('client_reference_id', referrerId);
    }
    return parsed.toString();
  } catch {
    return url;
  }
}

export function rewriteStripeLinks(html) {
  if (!html || html.indexOf('buy.stripe.com') === -1) return html;
  return html.replace(/https?:\/\/buy\.stripe\.com\/[^\s"'<>]+/g, (raw) => {
    const url = raw.replace(/&amp;/g, '&');
    return stripeLinkWithReferrer(url).replace(/&/g, '&amp;');
  });
}

export function rememberPurchaseReferrer() {
  return currentReferrer();
}
